import { useEffect } from 'react'

import { useDomain } from '@tribeplatform/react-components/common'
import {
  CookieManager,
  ScriptManager,
  TribeEmitter,
  TribeEmitterEvent,
  useTribeClient,
} from '@tribeplatform/react-sdk'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'
import { CustomCode } from '@tribeplatform/react-sdk/types'
import { alert, confirm } from '@tribeplatform/react-ui-kit/Dialog'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

const isCmpProviderEnabled = (customCodes: CustomCode[]) => {
  if (!customCodes) {
    return false
  }

  return customCodes.some(code => code.isCmpProvider)
}

type InitParams = {
  customCodes?: CustomCode[]
  domain: string
  domainSubfolder?: string
}

const init = ({ customCodes, domain, domainSubfolder }: InitParams) => {
  window.BM.toast = props => {
    toast({
      ...props,
      status: props.status || 'info',
    })
  }
  window.BM.confirm = confirm
  window.BM.alert = alert

  // legacy
  window.Tribe.toast = window.BM.toast
  window.Tribe.confirm = window.BM.confirm
  window.Tribe.alert = window.BM.alert
  // window.Tribe.prompt = prompt

  window.BM.scriptManager = new ScriptManager({
    domain,
    domainSubfolder,
  })
  window.BM.cookieManager = new CookieManager(isCmpProviderEnabled(customCodes))

  window.BM.on(TribeEmitterEvent.ON_COOKIE_CONSENT_CHANGE, () => {
    window.BM.scriptManager.processScripts()
  })

  TribeEmitter.emit(TribeEmitterEvent.READY, {})
  TribeEmitter.emit(TribeEmitterEvent.ON_COOKIE_CONSENT_CHANGE, {
    cookieConsent: window.BM.cookieManager.getCookieConsent(),
  })
}

export const useWindowTribe = () => {
  const { client } = useTribeClient()
  const { data: network } = useNetwork()
  const { domain, subfolder } = useDomain()

  useEffect(() => {
    if (window.BM) {
      if (!window.BM._loaded) {
        window.BM.on(TribeEmitterEvent.ON_LOAD, init)
      } else {
        init({
          customCodes: network.customCodes,
          domain,
          domainSubfolder: subfolder,
        })
      }
      window.BM.client = client
    }
  }, []) // We don't want this to be retriggered on any change
}
